export default __webpack_public_path__ + "static/media/exterior3.9bf5d007.ba374e0a.jpg";